<template>
    <!--@formatter:off-->
    <div ref="listWrap" class="list" @click="markInteraction" @focusin="markInteraction" @focusout="onFocusout($event)"
         v-clickoutside="changeToViewerAll" tabindex="-1" style="outline: none">

        <div class="tit">
            <h3 class="st metting">{{$t('SurveyEditorQuestionList_surveyList')}}</h3>

            <div class="bx_sorting3">
                <CustomSelect :options="surveyTypeOptions" :value="currentSurveyType" @input="setSurveyType"/>
            </div>
        </div>

        <template v-for="(question, index) in questions">
            <template v-if="(index === 0 && activeEditorIndex === -2) || index === activeEditorIndex">
                <SurveyQuestionEditorParentCounselWeek
                    v-if="question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK"
                    :key="question.questionNo"
                    :ref="`question:${index}`"
                    :question="question"
                    :question-index="index"
                    :siblings-count="questions.length"
                />
                <SurveyQuestionEditor
                    v-else
                    :key="question.questionNo"
                    :ref="`question:${index}`"
                    :question="question"
                    :question-index="index"
                    :siblings-count="questions.length"
                    @copyQuestion="onCopyQuestion"
                />
                <div v-if="question.type !== ANSWER_TYPE.PARENT_COUNSEL_WEEK" class="btn_move_area">
                    <button
                        ref="upButton"
                        type="button"
                        class="b_up"
                        @click.prevent="moveUpQuestion(index)"
                        v-ga-helper:click="{
                            view_category: '설문리스트',
                            view_area: '위로이동클릭',
                            view_label: '',
                        }"
                    >
                        {{ $t('SurveyEditorQuestionList_moveUp') }}
                    </button>
                    <button
                        ref="downButton"
                        type="button"
                        class="b_dn"
                        @click.prevent="moveDownQuestion(index)"
                        v-ga-helper:click="{
                            view_category: '설문리스트',
                            view_area: '아래로이동클릭',
                            view_label: '',
                        }"
                    >
                        {{ $t('SurveyEditorQuestionList_moveDown') }}
                    </button>
                </div>
            </template>
            <template v-else>
                <SurveyQuestionViewerParentCounselWeek
                    v-if="question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK"
                    :ref="`question:${index}`"
                    :question="question"
                    :question-index="index"
                    @changeActiveEditor="onChangeActiveEditor"
                />
                <SurveyQuestionViewer
                    v-else
                    :ref="`question:${index}`"
                    :question="question"
                    :question-index="index"
                    :key="question.questionNo"
                    @changeActiveEditor="onChangeActiveEditor"
                    v-ga-helper:changeActiveEditor.vueEvent="{
                        view_category: '설문리스트',
                        view_area: '질문수정하기클릭',
                        view_label: '',
                    }"
                />
            </template>
        </template>

        <div class="bx_btn">
            <button
                type="button"
                class="btn2"
                @click.prevent="addQuestion"
                v-ga-helper:click="{
                    view_category: '설문리스트',
                    view_area: '질문추가하기클릭',
                    view_label: '',
                }"
            >
              {{$t('SurveyEditorQuestionList_addQuestion')}}
            </button>
        </div>
    </div>
    <!--@formatter:on-->
</template>

<script>
import editorQuestionList from '@iamteacherpc/mixins/editorQuestionList.js';
import {mapFields} from 'vuex-map-fields';
import {
    ADD_QUESTION,
    MAX_QUESTION,
    NAMESPACE,
    RESTORE_PARENT_COUNSEL_WEEK,
    SAVE_PARENT_COUNSEL_WEEK, SET_SURVEY_TYPE_DEFAULT, SET_SURVEY_TYPE_PARENT_COUNSEL_WEEK,
} from '@common/store/modules/survey/editor.js';
import SurveyQuestionEditor from '@iamteacherpc/components/editor/SurveyQuestionEditor.vue';
import {createNamespacedHelpers} from 'vuex';
import {
    LIST_CHANGE,
    MOVE_DOWN_QUESTION,
    MOVE_UP_QUESTION,
    STOP_LIST_CHANGE,
} from '@/common/store/modules/common/editor/questionList.js';
import SurveyQuestionViewer from '@/iamteacherpc/components/editor/SurveyQuestionViewer.vue';
import SurveyQuestionEditorParentCounselWeek
    from '@iamteacherpc/components/editor/SurveyQuestionEditorParentCounselWeek.vue';
import {ANSWER_TYPE} from '@common/consts/survey.js';
import SurveyQuestionViewerParentCounselWeek
    from '@iamteacherpc/components/editor/SurveyQuestionViewerParentCounselWeek.vue';
import CustomSelect from '@iamteacherpc/components/common/CustomSelect.vue';
import {schema} from '@common/utils/webview.js';
import {requestAlert, requestConfirm} from '@iamteacherpc/utils/iframe.js';

const {mapActions} = createNamespacedHelpers(NAMESPACE);

const SURVEY_TYPE = {
    PARENT_COUNSEL_WEEK: 'PARENT_COUNSEL_WEEK',
    DEFAULT: 'DEFAULT',
};

export default {
    name: 'SurveyEditorQuestionList',
    components: {
        CustomSelect,
        SurveyQuestionViewerParentCounselWeek,
        SurveyQuestionEditorParentCounselWeek, SurveyQuestionViewer, SurveyQuestionEditor,
    },
    mixins: [
        editorQuestionList,
    ],

    data() {
        return {
            questionText: this.$t('common_question'),
            maxQuestion: MAX_QUESTION,

            surveyTypeOptions: [
                {
                    label: this.$t('SurveyEditorQuestionList_surveyListDefault'),
                    value: SURVEY_TYPE.DEFAULT,
                },
                {
                    label: this.$t('SurveyEditorQuestionList_surveyListCounselWeek'),
                    value: SURVEY_TYPE.PARENT_COUNSEL_WEEK,
                },
            ],
        };
    },

    computed: {
        ...mapFields(NAMESPACE, [
            'form.questions',
            'form.isAnonymity',
        ]),
        ...mapFields(NAMESPACE, {
            isStopListChange: 'options.stopListChange',
        }),

        ANSWER_TYPE() {
            return ANSWER_TYPE;
        },

        currentSurveyType() {
            return this.isParentCounselWeek ? SURVEY_TYPE.PARENT_COUNSEL_WEEK : SURVEY_TYPE.DEFAULT;
        },

        isParentCounselWeek() {
            return this.questions.some(question => question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK);
        },
    },

    methods: {
        ...mapActions({
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
            storeMoveUpQuestion: MOVE_UP_QUESTION,
            storeMoveDownQuestion: MOVE_DOWN_QUESTION,
            storeAddQuestion: ADD_QUESTION,

            storeSetSurveyTypeDefault: SET_SURVEY_TYPE_DEFAULT,
            storeSetSurveyTypeParentCounselWeek: SET_SURVEY_TYPE_PARENT_COUNSEL_WEEK,
        }),

        setSurveyType(value) {
            if (value === SURVEY_TYPE.DEFAULT) {
                this.setSurveyTypeDefault();
            } else {
                this.setSurveyTypeParentCounselWeek();
            }
        },

        setSurveyTypeDefault() {
            if (this.isParentCounselWeek) {
                this.storeSetSurveyTypeDefault();
            }
        },

        setSurveyTypeParentCounselWeek() {
            if (this.isParentCounselWeek) {
                return;
            }

            if (this.isAnonymity) {
                requestConfirm({
                    titleHtml: this.$t('SurveyEditorQuestionList_surveyListChangeAlert'),
                })
                    .then(() => {
                        this.storeSetSurveyTypeParentCounselWeek();
                    })
            } else {
                this.storeSetSurveyTypeParentCounselWeek();
            }
        },
    },
};
</script>

<style scoped>

</style>
